import React from 'react';
import classes from './PageHeader.module.css'

const PageHeader = (props) => {
  return (
    <div className={classes.Container}>
      {/* <hr /> */}
      <h1 className={classes.Header}>{props.title}</h1>
    </div>
  );
}

export default PageHeader;